import * as THREE from 'three';

export function PlaneBorder(
    width: number,
    height: number,
    radius: number,
    borderColor: number,
    borderThickness: number,
	dashed: boolean = false,
): THREE.Mesh {
	// Créer un chemin pour le tube
	const path = new THREE.Path();

	// Décalage pour centrer (x, y)
	const offsetX: number = -width / 2;
	const offsetY: number = -height / 2;

	// Dessiner le contour
	path.moveTo(offsetX + radius, offsetY);
	path.lineTo(offsetX + width - radius, offsetY);
	path.quadraticCurveTo(offsetX + width, offsetY, offsetX + width, offsetY + radius);
	path.lineTo(offsetX + width, offsetY + height - radius);
	path.quadraticCurveTo(offsetX + width, offsetY + height, offsetX + width - radius, offsetY + height);
	path.lineTo(offsetX + radius, offsetY + height);
	path.quadraticCurveTo(offsetX, offsetY + height, offsetX, offsetY + height - radius);
	path.lineTo(offsetX, offsetY + radius);
	path.quadraticCurveTo(offsetX, offsetY, offsetX + radius, offsetY);
	path.closePath();

	// Convertir en points 3D
	const points = path.getPoints(100);
	const points3D = points.map(p => new THREE.Vector3(p.x, p.y, 0));

	// Créer une courbe 3D fermée
	const curve = new THREE.CatmullRomCurve3(points3D);
	curve.closed = true;

	// Créer un tube autour de la courbe
	const geometry = new THREE.TubeGeometry(
		curve,
		2000, // segments - plus élevé pour plus de détails
		borderThickness * 0.5, // radius - moitié de l'épaisseur souhaitée
		8, // radialSegments - plus élevé pour un tube plus lisse
		true // closed
	);

	const material = new THREE.MeshBasicMaterial({ color: borderColor });
	const tube = new THREE.Mesh(geometry, material);

	// Stocker une référence au matériau pour faciliter les changements de couleur
	tube.userData.outlineMaterial = material;

	return tube;
}

// Fonction pour changer la couleur d'une bordure créée par PlaneBorder
export function changePlaneBorderColor(border: THREE.Object3D, color: THREE.Color): void {
	if (border && border.userData && border.userData.outlineMaterial) {
		const material = border.userData.outlineMaterial as THREE.MeshBasicMaterial;
		material.color = color;
	}
}
